const toExportFileNamePrefix = (gridDataKey: string): string =>
	gridDataKey
		.replace(/[^A-Za-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.toLowerCase() || "export";

export default toExportFileNamePrefix;
